import styles from './primeiroAdquirenteResumo.module.scss';
import { useContext, useEffect, useState } from 'react';
import { DiefCfemContext } from './../../../../contexts/DiefCfemContext';
import { IAquisicaoListagemResumo } from './../../../../interfaces/IAquisicao';
import { formatCurrency, removeFormatCurrency } from './../../../../utils/formatCurrency';
import { AquisicaoTableResumo } from './components/aquisicaoTableResumo/aquisicaoTableResumo';
import InformacaoBasica from '../../../../components/informacaoBasica/informacaoBasica';
import { aquisicoesTotais } from '../../../../utils/aquisicoesTotais';

function PrimeiroAdquirenteResumo() {
  const context = useContext(DiefCfemContext);
  const declaracaoPrimeiroAdquirente = context?.declaracaoPrimeiroAdquirente;

  const [aquisicaoListagemData, setAquisicaoListagemData] = useState<IAquisicaoListagemResumo[]>([]);

  useEffect(() => {
    const aquisicoes = declaracaoPrimeiroAdquirente?.aquisicoes || [];
    const novaListagemData: IAquisicaoListagemResumo[] = aquisicoesTotais(aquisicoes);

    setAquisicaoListagemData(novaListagemData);
  }, [declaracaoPrimeiroAdquirente]);

  const hasTributoCadastrado = aquisicaoListagemData.some((item) =>
    item.aquisicao?.componentesBaseDeCalculo?.some((baseCalculo) =>
      baseCalculo.codigosNCM?.some((codigoNCM) => (codigoNCM.tributosValores?.length ?? 0) > 0)
    )
  );

  const valorTotalDeducoes = aquisicaoListagemData
    .reduce(
      (accItem, item) =>
        accItem +
        (item.aquisicao?.componentesBaseDeCalculo?.reduce(
          (accBase, baseCalculo) =>
            accBase +
            (baseCalculo.codigosNCM?.reduce(
              (accNcm, codigoNCM) =>
                accNcm +
                (codigoNCM.tributosValores?.reduce(
                  (accTributo, tributo) => accTributo + (Number(tributo?.valor) || 0),
                  0
                ) ?? 0),
              0
            ) ?? 0),
          0
        ) ?? 0),
      0
    )
    .toString();

  return (
    <div className={styles.container}>
      <h4>Resumo DIEF-CFEM</h4>
      <div className={styles.containerTotais}>
        <div className={styles.totais}>
          <InformacaoBasica
            titulo='Valor Total das Aquisições'
            conteudo={formatCurrency(
              aquisicaoListagemData
                ?.reduce((acc, item) => acc + parseFloat(item.totais.valorTotalDeOperacao), 0)
                .toString()
            )}
          />
        </div>
        {hasTributoCadastrado && (
          <div className={styles.containerTotaisDeducao}>
            <div className={styles.totais}>
              <InformacaoBasica titulo='Valor Total das Deduções' conteudo={formatCurrency(valorTotalDeducoes)} />
            </div>
            <div className={styles.totais}>
              <InformacaoBasica
                titulo='Valor Total Líquido de Aquisições'
                conteudo={formatCurrency(
                  aquisicaoListagemData?.reduce((acc, item) => acc + parseFloat(item.totais.valorTotalDeOperacao), 0) -
                    removeFormatCurrency(valorTotalDeducoes)
                ).toString()}
              />
            </div>
          </div>
        )}
      </div>
      <AquisicaoTableResumo data={aquisicaoListagemData} isLoading={false} />
    </div>
  );
}

export default PrimeiroAdquirenteResumo;
